import { FieldModel } from "./FieldModel";

export class FieldValueEditViewModel {
    public field: FieldModel | null = null;
    public fieldValueId = 0;
    public value: any = null;
}
